import { db } from "@/lib/db";
import { ActionIcon, Button, Group, Modal, Stack, Text } from "@mantine/core";
import { useDisclosure } from "@mantine/hooks";
import { IconLocation } from "@tabler/icons-react";
import { useLiveQuery } from "dexie-react-hooks";
import { useState } from "react";

interface GetLocationProps {
    onEnableTracking: () => void;
    onDisableTracking: () => void;
    isTracking: boolean;
}

const GetLocation: React.FC<GetLocationProps> = ({  onEnableTracking, onDisableTracking, isTracking }) => {
    const [accessLocationModalOpen, accessLocationModalHandler] = useDisclosure(false);
    const [tracking, setTracking] = useState<boolean>(isTracking);
    const allowLocation = useLiveQuery(async () => {
        const allowLocationSetting = await db.userSettings.where('name').equals('allowLocation').first();
        return allowLocationSetting?.value as boolean;
    })

    const toggleTrack = () => {
        try {
            if(allowLocation === false){
                accessLocationModalHandler.toggle();
                onDisableTracking();
                setTracking(false);
                return;
            }
            if(tracking){
                onDisableTracking();
                setTracking(false);
            } else {
                if(allowLocation === null){
                    accessLocationModalHandler.toggle();
                    return;
                }
                setTracking(true);
                onEnableTracking();            
            }
        }
        catch (e) {
            console.error(e);
        }
    }

    const onOkClickHandler = async () => {
        await db.userSettings.where('name').equals('allowLocation').modify({ value: null });
        accessLocationModalHandler.toggle();
        onEnableTracking();
    }

    return (
        <>
            <ActionIcon variant='filled' color={isTracking ? 'green' : 'black'} size='lg' radius='xl' aria-label='Locate' style={{ position: 'absolute', top: 'calc(env(safe-area-inset-top, 0px) + 110px)', right: 20 }} onClick={toggleTrack} >
                <IconLocation color={isTracking ? 'black' : '#B3B3B3'} style={{ width: '70%', height: '70%', marginRight: 2 }} stroke={2} />
            </ActionIcon>
            {/* Above the bottom menu drawers, which share Mantine's default z-index and mount later. */}
            <Modal centered zIndex={300} opened={accessLocationModalOpen} onClose={accessLocationModalHandler.toggle} title='Location Access Required' withCloseButton={false}>
                <Stack>
                    <Text>Location access is required to use this feature.<br />Please enable location access in your browser settings.</Text>
                    <Group mt={10} align='center' justify='space-around'>
                        <Button w={100} color='pq-red' onClick={accessLocationModalHandler.toggle}>Cancel</Button>
                        <Button w={100} color='pq-red' onClick={onOkClickHandler}>OK</Button>
                    </Group>
                </Stack>
            </Modal>
        </>
    );
}

export default GetLocation;